/* Italian-style formatting helpers. */

export function formatEUR(value, opts = {}) {
  const { showDecimals = false } = opts;
  const v = Number.isFinite(value) ? value : 0;
  return new Intl.NumberFormat("it-IT", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: showDecimals ? 2 : 0,
    maximumFractionDigits: showDecimals ? 2 : 0,
  }).format(v);
}

export function formatKm(value) {
  const v = Number.isFinite(value) ? value : 0;
  return `${new Intl.NumberFormat("it-IT").format(v)} km`;
}

export function formatNumber(value) {
  const v = Number.isFinite(value) ? value : 0;
  return new Intl.NumberFormat("it-IT").format(v);
}

export function countryFlag(code) {
  const c = (code || "").toUpperCase();
  if (c === "IT") return "🇮🇹";
  if (c === "DE") return "🇩🇪";
  return "🏳️";
}

export function opportunityStyle(index) {
  switch (index) {
    case "strong_buy":
      return {
        dot: "bg-emerald-500",
        pill: "bg-emerald-50 text-emerald-700 border-emerald-200",
        solid: "bg-emerald-500 text-white",
      };
    case "good_opportunity":
      return {
        dot: "bg-yellow-500",
        pill: "bg-yellow-50 text-yellow-700 border-yellow-200",
        solid: "bg-yellow-500 text-slate-900",
      };
    case "neutral":
      return {
        dot: "bg-orange-500",
        pill: "bg-orange-50 text-orange-700 border-orange-200",
        solid: "bg-orange-500 text-white",
      };
    case "high_risk":
    default:
      return {
        dot: "bg-red-500",
        pill: "bg-red-50 text-red-700 border-red-200",
        solid: "bg-red-500 text-white",
      };
  }
}

export function statusStyle(status) {
  switch (status) {
    case "available":
      return "bg-emerald-50 text-emerald-700 border border-emerald-200";
    case "reserved":
      return "bg-amber-50 text-amber-700 border border-amber-200";
    case "incoming":
      return "bg-sky-50 text-sky-700 border border-sky-200";
    case "sold":
      return "bg-slate-100 text-slate-500 border border-slate-200";
    default:
      return "bg-slate-100 text-slate-600 border border-slate-200";
  }
}
